export class TypeGroup {
  name: String;
  events: Array<number>;
}
